import React, { FC, useEffect } from 'react'
import { useInView } from 'react-intersection-observer'
import { trackGAEvent } from '@moonpig/web-core-analytics'
import { createLinkHref } from '@moonpig/web-core-link'
import { Carousel } from '@moonpig/web-shared-components'
import { ModuleMissionButtonsFragment } from './__generated__/fragment'
import { ModuleSection } from '../../components/ModuleContainer'
import { useTracking } from './tracking'
import { Button } from '../../components/MissionButton/Button'
import { Module } from '../types'
import { ImageButton } from '../../components/MissionButton/ImageButton'

export const MissionButtonsModule: FC<Module<ModuleMissionButtonsFragment>> = ({
  module: { missionButtons, meta, ...rest },
  context,
}) => {
  const shouldShowImageMissionButtons = context.layout === 'home'
  const [ref, inView] = useInView({
    threshold: 0.8,
    triggerOnce: true,
  })

  const { viewList, selectItem } = useTracking(missionButtons, meta)

  useEffect(() => {
    if (inView) {
      trackGAEvent(viewList())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView])

  return (
    <ModuleSection
      {...rest}
      {...context}
      data-testid="module-mission-buttons"
      withContainer
      fullWidthOnMobile
      ref={ref}
      padding={{
        py: {
          xs: shouldShowImageMissionButtons ? 2 : 6,
          md: shouldShowImageMissionButtons ? 0 : 7,
        },
      }}
    >
      <Carousel hideScrollButtons={missionButtons.length < 8}>
        {missionButtons
          .map((item, index) => {
            if (shouldShowImageMissionButtons) {
              return item.image ? (
                <ImageButton
                  key={item.title}
                  title={item.title}
                  linkHref={createLinkHref({
                    url: item.url,
                    trackEvent: selectItem(index),
                  })}
                  imageUrl={item.image}
                />
              ) : null
            }

            return (
              <Button
                key={item.title}
                title={item.title}
                linkHref={createLinkHref({
                  url: item.url,
                  trackEvent: selectItem(index),
                })}
              />
            )
          })
          .filter(Boolean)}
      </Carousel>
    </ModuleSection>
  )
}
